import React from 'react';
import { translate as t } from 'admin-on-rest';
import plz from 'await-plz';
import { CircularProgress, SelectField, MenuItem } from 'material-ui';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';

class FAQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      FAQs: [],
      selectedFAQs: [],
    };
  }

  componentWillMount = async () => {
    const [err, res] = await plz(
      fetch(`${API_BASE_URL}/faq?range=[0,9999]`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'content-type': 'application/json',
        },
      })
    );
    if (err) console.log('faq fetch err', err);
    if (!res) console.log('no faq fetch response', res);

    this.setState({ FAQs: res, selectedFAQs: this.props.values ? this.props.values.faqs : [] });
  };

  handleSelectChange = (event, index, values) => {
    this.setState({ selectedFAQs: values });
    this.props.onChange('faqs', this.props.id, values);
  };

  render() {
    const { FAQs, selectedFAQs } = this.state;
    return (
      <div className="block-field">
        {!FAQs ? (
          <CircularProgress />
        ) : (
          <SelectField
            floatingLabelText="FAQs"
            value={selectedFAQs}
            onChange={this.handleSelectChange}
            multiple
            fullWidth
          >
            {FAQs.map((faq) => (
              <MenuItem
                key={faq._id}
                value={faq._id}
                primaryText={faq.identifier}
                checked={selectedFAQs && selectedFAQs.includes(faq._id)}
              />
            ))}
          </SelectField>
        )}
      </div>
    );
  }
}

export default t(FAQ);
